import React from "react";
import EmojiPicker from "emoji-picker-react";
import { IExlyEmojiPickerProps } from "./ExlyEmojiPicker.interfaces";

/**
 * ExlyEmojiPicker Component
 * A wrapper for the EmojiPicker component from the 'emoji-picker-react' library.
 * This component allows users to select emojis and can be customized with props.
 * More can be refered from -
 * https://www.npmjs.com/package/emoji-picker-react
 */
const ExlyEmojiPicker = ({
  height = 450,
  width = 350,
  autoFocusSearch = true,
  onEmojiClick,
  emojiStyle,
  overrideProps = {},
}: IExlyEmojiPickerProps) => {
  return (
    <EmojiPicker
      autoFocusSearch={autoFocusSearch}
      emojiStyle={emojiStyle}
      onEmojiClick={onEmojiClick}
      height={height}
      width={width}
      {...overrideProps}
    />
  );
};

export default ExlyEmojiPicker;
